import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Motion";

const SPANS = ["md:col-span-7", "md:col-span-5", "md:col-span-5", "md:col-span-7"];

export const CaseCard = ({ cs, index = 0 }) => (
    <Link
        to={`/work/${cs.slug}`}
        data-testid={`work-card-${cs.slug}`}
        className={`group relative block overflow-hidden border border-line bg-card transition-colors duration-500 hover:border-vermilion ${SPANS[index % 4]}`}
    >
        <div className="relative aspect-[16/11] overflow-hidden">
            <img
                src={cs.hero_image}
                alt={cs.title}
                loading="lazy"
                className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/20 to-transparent" />
            {cs.sample && (
                <span className="absolute right-4 top-4 border border-paper/30 bg-ink/60 px-2 py-1 font-mono text-[9px] uppercase tracking-[0.2em] text-paper/80 backdrop-blur-sm">
                    Sample
                </span>
            )}
            <span className="absolute left-4 top-4 bg-ink/60 px-2 py-1 font-mono text-[9px] uppercase tracking-[0.2em] text-paper/90 backdrop-blur-sm">
                {cs.category} · {cs.year}
            </span>
        </div>
        <div className="flex items-end justify-between gap-4 p-5 md:p-7">
            <div>
                <h3 className="font-display text-3xl md:text-4xl font-light text-paper transition-colors duration-300 group-hover:text-vermilion">
                    {cs.title}
                </h3>
                <p className="mt-2 font-mono text-[10px] uppercase tracking-[0.22em] text-smoke">
                    {cs.client}
                </p>
            </div>
            <span className="flex h-11 w-11 shrink-0 items-center justify-center border border-line transition-all duration-300 group-hover:border-vermilion group-hover:bg-vermilion">
                <ArrowUpRight className="h-4 w-4 text-paper transition-transform duration-300 group-hover:rotate-45" />
            </span>
        </div>
    </Link>
);

export default function WorkGrid({ items }) {
    return (
        <div className="grid grid-cols-1 gap-6 md:grid-cols-12 md:gap-8" data-testid="work-grid">
            {items.map((cs, i) => (
                <Reveal key={cs.slug} delay={(i % 2) * 0.08} className="md:col-span-12">
                    <CaseCard cs={cs} index={i} />
                </Reveal>
            ))}
        </div>
    );
}
